import { Url } from "@/helpers/url";
import type { B2cCategory, B2cProductPayload, B2cProductSearchPayload } from "@/generated/graphql/b2c";
import type { Categories } from "@/services/categories";

const getProductCategory = (categories: Array<B2cCategory>, prefer = 'long') => {
  if (prefer === 'long') {
    return categories.slice().sort((a, b) => a.level - b.level)[0]?.id;
  }

  return categories.find((category) => category.id === prefer)?.id ?? categories[0]?.id;
};

export const createProductPath = (product: Pick<B2cProductSearchPayload, 'categories' | 'productInfo'>, categories: Categories, prefer = 'long') => {
  const category = getProductCategory(product.categories.filter(item => categories.getItem(item.id)), prefer);
  const slug = product.productInfo!.slug;
  const path = categories.getItemPath(category);

  return [...path, slug];
};

export const createProductUrl = (product: Pick<B2cProductSearchPayload, 'categories' | 'productInfo'> | Pick<B2cProductPayload, 'categories' | 'productInfo'>, categories: Categories, prefer = 'long', originalMpn?: string) => {
  const search = originalMpn ? `?originalMpn=${originalMpn}` : undefined;
  return Url.to("dynamic-route", { dynamicPath: createProductPath(product, categories) }, search);
};